import {
  ActionIcon,
  Anchor,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Select,
  Switch,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconEdit,
  IconPlus,
  IconSearch,
  IconTimeDuration15,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { getArticleCategory } from "../../../api/ApiArticle";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import UpdateOrderNumberView from "./updateorderNumberView";
import { useLocation } from "react-router-dom";
// interface SearchCriteria {
//   keySearch?: string;
//   status?: string;
//   location?: string;
// }

const ArticleRecruitment = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<any[]>([]);
  const [dataArticleCategory, setDataArticleCategory] = useState<any[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;

  const optionSearch = {
    isActive: [
      {
        value: "2",
        label: "Bản nháp",
        "data-test-subj": "titanOption",
      },
      {
        value: "1",
        label: "Đã duyệt",
        "data-test-subj": "titanOption",
      },
      {
        value: "0",
        label: "Chờ duyệt",
      },
    ],
  };
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const formSearchInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
      status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
      ArticleCategoryId: "60",
    },
  });
  const getStatusColor = (status: any) => {
    switch (status) {
      case 0:
        return "red";
      case 1:
        return "green";
      case 2:
        return "subdued";
      case "Y":
        return "#f9fd04";
      case "N":
        return "gray";
      default:
        return "subdued";
    }
  };
  const styleTableMantine = {
    fontWeight: "500",
  };
  const updateLocalData = (
    id: number,
    field: "active" | "priority",
    value: string
  ) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "thumnail",
        header: "Ảnh ",
        size: 135,
        Cell: ({ row }) => {
          const url = row.original.thumnail;
          if (!url) return null;
          return (
            <img
              src={url}
              alt={row.original.title}
              style={{ width: "80px", height: "60px", objectFit: "contain" }}
            />
          );
        },
      },
      {
        accessorKey: "title",
        header: "Tiêu đề",
        size: 300,
      },

      {
        accessorKey: "link",
        header: "Đường dẫn",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 135,
        Cell: ({ row }) => (
          <Group>
            <a
              href={`${hacomUrl}/${row.original.url}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1c7ed6", textDecoration: "underline" }}
            >
              Xem trang bài viết
            </a>
          </Group>
        ),
      },
      {
        accessorKey: "summary",
        header: "Nội dung",
        size: 250,
        Cell: ({ row }) => <Text>{row.original.summary}</Text>,
      },
      {
        accessorKey: "ordering",
        header: "Thứ tự",
        size: 120,
        Cell: ({ row }) => {
          return (
            <Anchor
              fw={500}
              c="blue"
              ml={10}
              underline="hover"
              style={{ cursor: "pointer" }}
              onClick={() => {
                const id = row.original.id;
                const orderNumber = row.original.ordering;
                console.log("data test", data);
                modals.openConfirmModal({
                  title: (
                    <>
                      <div color="white">
                        <Title order={5}>Cập nhật STT !</Title>
                      </div>
                    </>
                  ),
                  children: (
                    <UpdateOrderNumberView
                      onSearch={() => fetchData()}
                      id={id}
                      orderNumber={orderNumber ?? 0}
                      data={row.original}
                    />
                  ),
                  confirmProps: { display: "none" },
                  cancelProps: { display: "none" },
                });
              }}
            >
              {row.original.ordering}
            </Anchor>
          );
        },
      },
      {
        accessorKey: "postedDate",
        header: "Ngày đăng tải",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm">
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "visit",
        header: "Lượt xem",
        size: 135,
        Cell: ({ row }) => (
          <Text fw={500} c="#FF0000" ml={10}>
            {row.original.visit}
          </Text>
        ),
      },
      {
        accessorKey: "likeCount",
        header: "Lượt thích",
        size: 135,
      },
      {
        accessorKey: "commentCount",
        header: "Lượt bình luận",
        size: 135,
      },
      {
        accessorKey: "reviewCount",
        header: "Lượt đánh giá",
        size: 135,
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 135,
        Cell: ({ row }) => (
          <>
            <Switch
              checked={row.original.status === 1}
              color="blue"
              size="xs"
              mr={3}
              onClick={async (e: any) => {
                open();
                await featuredActive(row.original.id, "status");
              }}
            />
            <Text>
              {" "}
              {row.original.status === 1
                ? "Hoạt động"
                : row.original.status === 2
                ? "Bản nháp"
                : "Chờ duyệt"}
            </Text>
          </>
        ),
      },
      {
        accessorKey: "isStricking",
        header: "Nổi bật",
        size: 135,
        Cell: ({ row }) => (
          <>
            <Switch
              checked={row.original.isStricking === "Y"}
              color="blue"
              size="xs"
              mr={3}
              onClick={async (e: any) => {
                open();
                await featuredActive(row.original.id, "priority");
              }}
            />
            <Text>
              {" "}
              {row.original.isStricking === "Y" ? "Tắt nổi bật" : "Mở nổi bật"}
            </Text>
          </>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác ",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="yellow"
                onClick={() => editItem(row.original.id)}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={async () => {
                  await deleteItem([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
      pagination.pageSize
    }&ArticleCategoryId=60`;
    if (formSearchInput.getValues().keySearch) {
      url += `&KeySearch=${formSearchInput.getValues().keySearch}`;
    }
    if (formSearchInput.getValues().status) {
      url += `&Status=${formSearchInput.getValues().status}`;
    }
    // if (formSearchInput.getValues().ArticleCategoryId) {
    //   url += `&ArticleCategoryId=${
    //     formSearchInput.getValues().ArticleCategoryId
    //   }`;
    // }
    try {
      const response = await repository.get(
        `${API_ROUTE.GET_LIST_ARTICLE_LIST}${url}`
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(formSearchInput.getValues())
      );
    }
  };

  const loadArticleCategory = async () => {
    setDataArticleCategory([]);
    const data = await getArticleCategory("Skip=0&Take=1000");
    const transformedData = data?.data.map((item: any, index: number) => ({
      value: item.id.toString(),
      label: item.name,
    }));
    setDataArticleCategory(transformedData);
  };

  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới bài viết</Title>
          </div>
        </>
      ),
      children: <CreateView datas={data} onSearch={() => fetchData()} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  const featuredActive = async (id: number, type: string, order?: number) => {
    if (id < 1) NotificationExtension.Fails("Mã danh mục không tồn tại !");
    else {
      setIsLoading(true);
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      try {
        let urlSearch =
          type === "status"
            ? API_ROUTE.MODIFY_ARTICLE_LIST_STATUS + id
            : type === "priority"
            ? API_ROUTE.MODIFY_ARTICLE_LIST_STICKING + id
            : type === "order"
            ? API_ROUTE.MODIFY_ARTICLE_LIST_ORDER + id + "&order=" + order
            : "";
        let callapi = await repository.post<MessageResponse<boolean>>(
          urlSearch
        );
        close();
        if (isNullOrUndefined(callapi)) {
          NotificationExtension.Fails(
            "Thao tác không thành công, xin vui lòng thử lại !"
          );
        } else {
          if (callapi?.success) {
            NotificationExtension.Success("Thao tác thành công !");
            await fetchData();
          } else NotificationExtension.Fails("Thao tác thất bại !");
        }
        return callapi?.data;
      } catch (error: any) {
        throw new Error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  const modalChangeOrderArticle = (id: number, orderNumber: any) => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Cập nhật STT !</Title>
          </div>
        </>
      ),
      children: (
        <UpdateOrderNumberView
          onSearch={() => fetchData()}
          id={id}
          orderNumber={orderNumber ?? 0}
          data={data}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa bài viết</Title>
        </>
      ),
      children: <DeleteView onSearch={() => fetchData()} idItem={idItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa bài viết!</Title>
        </>
      ),

      children: <EditView id={id} onSearch={() => fetchData()} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["status", "priority", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    // mantineTableBodyCellProps: ({ row }) => ({
    //   style: styleTableMantine,
    // }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    fetchData();
    loadArticleCategory();
  }, [pagination]);
  return (
    <Box>
      <Group gap={0} justify="space-between" mb={10}>
        <BreadCrumb></BreadCrumb>
      </Group>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        {/* Thông báo thời gian đồng bộ dữ liệu lên web */}
        <Box
          style={{
            background: "#fffbe6",
            border: "1.5px solid #ffe58f",
            borderRadius: 8,
            padding: "5px",
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 600,
            color: "#ad6800",
            fontSize: 14,
          }}
        >
          <IconTimeDuration15
            size={22}
            color="#faad14"
            style={{ marginRight: 6 }}
          />
          <span>
            <b>Lưu ý:</b> Sau khi cập nhật,có thể dữ liệu sẽ được đồng bộ lên
            website trong khoảng <b>15-30 phút</b>. Vui lòng kiểm tra lại sau
            thời gian này để thấy thay đổi.
          </span>
        </Box>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={formSearchInput.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...formSearchInput.getInputProps("keySearch")}
              />
              <Select
                placeholder="Trạng thái"
                data={optionSearch.isActive}
                key={formSearchInput.key("status")}
                clearable
                {...formSearchInput.getInputProps("status")}
              />
              {/* <Select
                placeholder="Loại bài viết"
                data={dataArticleCategory}
                key={formSearchInput.key("ArticleCategoryId")}
                readOnly
                searchable
                {...formSearchInput.getInputProps("ArticleCategoryId")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={500}
              /> */}
              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
          <Group>
            <Button
              mt={10}
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                openModal();
              }}
            >
              Thêm mới
            </Button>
            <Button
              mt={10}
              mr={10}
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              onClick={async () => {
                const selectedIds = Object.keys(rowSelection).map(
                  (key) => data[Number(key)].id
                );
                if (selectedIds && selectedIds.length < 1) {
                  NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                  return null;
                }
                await deleteItem(selectedIds);
              }}
            >
              Xóa (Đã chọn)
            </Button>
          </Group>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default ArticleRecruitment;
